import { ColorTokenType, TextColorType } from '../../interfaces/colors';
import { defaultTheme } from './../theme/default';
interface IVariants<T> {
  [key: string]: T;
}

interface IBadgeVariant {
  backgroundColor: ColorTokenType;
  borderColor?: ColorTokenType;
  textColor: TextColorType;
  closeIconColor?: ColorTokenType;
}

interface IScoreVariant {
  backgroundColor: ColorTokenType;
  borderColor?: ColorTokenType;
  textColor: TextColorType;
}
interface IPrimaryButtonVariantStyle {
  backgroundColor: string;
  borderColor: string;
  backgroundColorHover: string;
  borderColorHover: string;
  backgroundColorPress: string;
  borderColorPress: string;
}

interface ISecondaryButtonVariantStyle extends IPrimaryButtonVariantStyle {
  textColor: TextColorType;
}

interface IButtonPrimaryVariantSize {
  padding: string;
  borderRadius: string;
}

export type ColorVariantType =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'default';

export type ButtonPrimaryVariantType =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

export type ButtonsSizeType = 's' | 'm' | 'l';

export const badgeVariantStyle: IVariants<IBadgeVariant> = {
  success: {
    backgroundColor: 'successLight',
    borderColor: 'borderSuccess',
    textColor: 'success',
    closeIconColor: 'success',
  },
  danger: {
    backgroundColor: 'dangerLight',
    borderColor: 'borderDanger',
    textColor: 'danger',
    closeIconColor: 'danger',
  },
  info: {
    backgroundColor: 'interactiveLight',
    borderColor: 'borderInteractive',
    textColor: 'link',
    closeIconColor: 'interactive',
  },
  warning: {
    backgroundColor: 'warningLight',
    borderColor: 'borderWarning',
    textColor: 'warning',
    closeIconColor: 'warning',
  },
  default: {
    backgroundColor: 'neutralLight',
    borderColor: 'borderNeutral',
    textColor: 'secondary',
    closeIconColor: 'neutral',
  },
};

// color pattern goes from 1 red/ most negative to 5 green/ most positive
export const scoreVariantStyle: IVariants<IScoreVariant> = {
  score1: {
    backgroundColor: 'baseScoreLight1',
    borderColor: 'borderBaseScore1',
    textColor: 'score1',
  },
  score2: {
    backgroundColor: 'baseScoreLight2',
    borderColor: 'borderBaseScore2',
    textColor: 'score2',
  },
  score3: {
    backgroundColor: 'baseScoreLight3',
    borderColor: 'borderBaseScore3',
    textColor: 'score3',
  },
  score4: {
    backgroundColor: 'baseScoreLight4',
    borderColor: 'borderBaseScore4',
    textColor: 'score4',
  },
  score5: {
    backgroundColor: 'baseScoreLight5',
    borderColor: 'borderBaseScore5',
    textColor: 'score5',
  },
  default: {
    backgroundColor: 'neutralLight',
    borderColor: 'borderNeutral',
    textColor: 'neutral',
  },
};

export const buttonPrimaryVariantStyle: IVariants<IPrimaryButtonVariantStyle> = {
    success: {
      backgroundColor: defaultTheme.buttonColor.primary.success.default,
      borderColor: defaultTheme.buttonColor.primary.success.default,
      backgroundColorHover: defaultTheme.buttonColor.primary.success.hover,
      borderColorHover: defaultTheme.buttonColor.primary.success.hover,
      backgroundColorPress: defaultTheme.buttonColor.primary.success.press,
      borderColorPress: defaultTheme.buttonColor.primary.success.press,
    },
    danger: {
      backgroundColor: defaultTheme.buttonColor.primary.danger.default,
      borderColor: defaultTheme.buttonColor.primary.danger.default,
      backgroundColorHover: defaultTheme.buttonColor.primary.danger.hover,
      borderColorHover: defaultTheme.buttonColor.primary.danger.hover,
      backgroundColorPress: defaultTheme.buttonColor.primary.danger.press,
      borderColorPress: defaultTheme.buttonColor.primary.danger.press,
    },
    info: {
      backgroundColor: defaultTheme.buttonColor.primary.info.default,
      borderColor: defaultTheme.buttonColor.primary.info.default,
      backgroundColorHover: defaultTheme.buttonColor.primary.info.hover,
      borderColorHover: defaultTheme.buttonColor.primary.info.hover,
      backgroundColorPress: defaultTheme.buttonColor.primary.info.press,
      borderColorPress: defaultTheme.buttonColor.primary.info.press,
    },
    warning: {
      backgroundColor: defaultTheme.buttonColor.primary.warning.default,
      borderColor: defaultTheme.buttonColor.primary.warning.default,
      backgroundColorHover: defaultTheme.buttonColor.primary.warning.hover,
      borderColorHover: defaultTheme.buttonColor.primary.warning.hover,
      backgroundColorPress: defaultTheme.buttonColor.primary.warning.press,
      borderColorPress: defaultTheme.buttonColor.primary.warning.press,
    },
  };

export const buttonSecondaryVariantStyle: IVariants<ISecondaryButtonVariantStyle> = {
    danger: {
      backgroundColor: defaultTheme.buttonColor.secondary.danger.default,
      borderColor: defaultTheme.colorToken.borderDanger,
      textColor: 'danger',
      backgroundColorHover: defaultTheme.buttonColor.secondary.danger.hover,
      borderColorHover: defaultTheme.buttonColor.secondary.danger.hover,
      backgroundColorPress: defaultTheme.buttonColor.secondary.danger.press,
      borderColorPress: defaultTheme.buttonColor.secondary.danger.press,
    },
    default: {
      backgroundColor: defaultTheme.buttonColor.secondary.default.default,
      borderColor: defaultTheme.colorToken.borderNeutral,
      textColor: 'textBlack',
      backgroundColorHover: defaultTheme.buttonColor.secondary.default.hover,
      borderColorHover: defaultTheme.buttonColor.secondary.default.hover,
      backgroundColorPress: defaultTheme.buttonColor.secondary.default.press,
      borderColorPress: defaultTheme.buttonColor.secondary.default.press,
    },
  };

export const buttonsVariantSize: IVariants<IButtonPrimaryVariantSize> = {
  s: {
    padding: `${defaultTheme.spacing[4]} ${defaultTheme.spacing[8]}`,
    borderRadius: `${defaultTheme.spacing[4]}`,
  },
  m: {
    padding: `${defaultTheme.spacing[8]} ${defaultTheme.spacing[12]}`,
    borderRadius: `${defaultTheme.spacing[6]}`,
  },
  l: {
    padding: `${defaultTheme.spacing[8]} ${defaultTheme.spacing[12]}`,
    borderRadius: `${defaultTheme.spacing[8]}`,
  },
};
